import { CheckIcon } from '../../../icons';
import { Chip } from '../../atoms/Chip';
import { type ChipTabProps, useChipTab } from './useChipTab';

type Props = ChipTabProps;

export function ChipTab(props: Props) {
  const {
    isSelected,
    displayLabel,
    variant,
    size,
    handleClick,
  } = useChipTab(props);

  return (
    <Chip
      id={props.id}
      label={displayLabel}
      variant={variant}
      color="default"
      size={size}
      disabled={props.disabled}
      icon={isSelected ? <CheckIcon color="inherit" fontSize="small" /> : undefined}
      onClick={handleClick}
      role="tab"
      aria-selected={isSelected}
      tabIndex={isSelected ? 0 : -1}
      data-testid={props['data-testid']}
    />
  );
}
